// extracted by mini-css-extract-plugin
export var activeDot = "_8r-c";
export var buttonContainer = "_8r-9";
export var channelButton = "_8r-a";
export var clickable = "_8r-d";
export var content = "_8r-0";
export var contentFull = "_8r-2";
export var contentThird = "_8r-1";
export var contentWrapper = "_8r-7";
export var description = "_8r-5";
export var heightShort = "_8r-f";
export var image = "_8r-3";
export var imageContainer = "_8r-4";
export var selectButton = "_8r-e";
export var spinnerContainer = "_8r-b";
export var titleContent = "_8r-8";
export var titleWrapper = "_8r-6";